import React, { forwardRef } from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'

const TimeLineItem = forwardRef((props, ref) => {
    const { children, className, isLast, media, horizontal, connectClassName } = props

    return (
        <li
            className={classNames(
                'timeline-item',
                isLast ? 'timeline-item-last' : '',
                horizontal && (isLast ? 'flex-none' : 'flex-1'),
                className
            )}
            ref={ref}
        >
            <div className={classNames('timeline-item-wrapper', horizontal && 'flex-col')}>
                <div className={classNames('timeline-item-media', horizontal && 'flex-row')}>
                    <div className="timeline-item-media-content">
                        {media || (
                            <div className="timeline-item-media-default" />
                        )}
                    </div>
                    {!isLast && <div className={classNames('timeline-connect', horizontal && 'h-0.5 grow mx-2', connectClassName)} />}
                </div>
                <div
                    className={classNames(
                        'timeline-item-content',
                        isLast && 'timeline-item-content-last',
                        horizontal && 'm-0 pb-0 pt-2'
                    )}
                >
                    {children}
                </div>
            </div>
        </li>
    )
})

TimeLineItem.propTypes = {
    media: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
    horizontal: PropTypes.bool,
    connectClassName: PropTypes.string,
}

export default TimeLineItem
